// extracted by css-extract-rspack-plugin
export default {"badge":"badge-MVVkFF","badge-primary":"badge-primary-i0yOzY","badgePrimary":"badge-primary-i0yOzY","badge-green":"badge-green-Xlx94W","badgeGreen":"badge-green-Xlx94W"};